import {useEffect} from "react";
import {useLocalStorage} from "usehooks-ts";

export const AUTH_TOKEN_KEY = "authToken";

export const LegacyTokenHandler = () => {
  const [, , removeAuthToken] = useLocalStorage<string | null>(AUTH_TOKEN_KEY, null);
  useEffect(() => {
    removeAuthToken();
  })

  return null;
}